import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import type { ISourceOptions } from '@tsparticles/engine';
import { ParticlesService } from '../../services/particles.service';

@Component({
    selector: 'app-home-seven',
    templateUrl: './home-seven.component.html',
    styleUrls: ['./home-seven.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeSevenComponent implements OnInit {

  readonly availableThemes = ['default', 'tech'];

  myStyle: Record<string, string> = {};
  myParams: ISourceOptions = {};
  currentTheme = 'default';
  particlesCanvasId = 'tsparticles-home-seven';

  private loadSeq = 0;

  constructor(
    private viewportScroller: ViewportScroller,
    private particlesService: ParticlesService
  ) {}

  public onClick(elementId: string): void {
    this.viewportScroller.scrollToAnchor(elementId);
  }

  ngOnInit() {
    this.myStyle = { ...this.particlesService.hostStyle };
    this.applyTheme('default');
  }

  setParticleTheme(theme: string, event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();
    if (!theme || theme === this.currentTheme) {
      return;
    }
    this.applyTheme(theme);
  }

  private applyTheme(theme: string) {
    const seq = ++this.loadSeq;
    this.currentTheme = theme;
    this.myParams =
      theme === 'tech'
        ? this.particlesService.getTechOptions()
        : this.particlesService.getDefaultOptions();
    // id único fuerza recarga limpia del canvas en ngx-particles
    this.particlesCanvasId = `tsparticles-home-seven-${theme}-${seq}`;
  }

  getThemeDisplayName(theme: string): string {
    return this.particlesService.getThemeDisplayName(theme);
  }

  getThemeIcon(theme: string): string {
    return this.particlesService.getThemeIcon(theme);
  }
}
